import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.svg`
  transform-origin: center;
  transform: rotate(${props => props.direction === 'left' ? 180 : 0}deg);
`

export default ({ color, direction, ...rest }) => (
  <Wrapper direction={direction} {...rest} width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.1.47l5.525 5.765L9.1 12M14.656 6.235H.03" stroke={color || '#EEEEEA'}
      fill="none" fillRule="evenodd" />
  </Wrapper>
);


// WEBPACK FOOTER //
// ./src/ui/components/generic/Arrow.js